





































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import mixin from './mixin'

@Component({
	name: 'AiiAddTask',
})
export default class AddTask extends Mixins(mixin) {}
